import {ChipProps} from '@mui/material';

type VariantType = 'warning' | 'error' | 'success' | 'info' | 'primary' | 'secondary' | 'default';

type TagChipProps = ChipProps & {
	usePrimaryTextColor?: boolean;
	bgColor?: string;
};

export enum ChipColorEnum {
	PRIMARY = 'primary',
	SECONDARY = 'secondary',
	INFO = 'info',
	SUCCESS = 'success',
	WARNING = 'warning',
	ERROR = 'error',
	DEFAULT = 'default',
}

export type {TagChipProps, VariantType};
